<script>
import axios from '@/utils/axios';
import { wById } from '@/utils/warehouse.js';

export default {
inject: ['setLoading'],    
 data() {
  return { 
   title: "Inventory",
   text: "Inventory",
   app_currency: '',
   data: [],
   status: '',
   search: '',
   pagination: {
    current_page: 1,
    per_page: 25,
    last_page: 1,
    total: 0,
    links: []
   },
   warehouse: '',
   brands: [],
   selectedBrand: null,
   items: [],
   selectedItem: null,
  };
},

computed: {
  text1(){
   return `Warehouse Items (${this.pagination.total})`; 
  },
  serialNo(){
   return (this.pagination.current_page - 1) * this.pagination.per_page; 
  }
},

async mounted() {
 const warehouse_id = this.$route.params.warehouse_id;  
 this.warehouseById(warehouse_id); 
 this.warehouseItems(warehouse_id);
 this.app_currency = await this.$appCurrency();
 this.loadBrands();
}, 

methods: {

  async loadItemsByBrand(brand_id) {
  if (!brand_id) {
    this.items = [];
    this.selectedItem = null;
    return;
  }
  try {
    const response = await axios.get(`/items/${brand_id}/brand-wise`);
    this.items = response.data.data;
  } catch(error) {
    this.$swalToast(error.message, 'error');
  }
},

async onBrandChange() {
  this.selectedItem = null; 
  await this.loadItemsByBrand(this.selectedBrand);
  this.warehouseItems(this.$route.params.warehouse_id, 1);
},

onItemChange() {
  this.warehouseItems(this.$route.params.warehouse_id, 1);
},


  async exportCSV() {
  this.setLoading(true);
  try {
    const warehouse_id = this.$route.params.warehouse_id;
    const params = { export: 'csv' };
    if (this.search.trim()) params.search = this.search.trim();
    if (this.selectedBrand) params.brand_id = this.selectedBrand;
    if (this.selectedItem) params.item_id = this.selectedItem;

    const query_string = new URLSearchParams(params).toString();
    const response = await axios.get(`/inventory/stocks/warehouse-items/${warehouse_id}?${query_string}`, {
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `warehouse-items-${this.warehouse?.name || warehouse_id}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    this.$swalToast('Failed to export CSV', 'error');
  } finally {
    this.setLoading(false);
  }
},

  async loadBrands() {
  try {
    const response = await axios.get('/brands/dropdown');
    this.brands = response.data.data;
  } catch(error) {
    this.$swalToast(error.message, 'error');
  }
},

 async warehouseById(warehouse_id){
  try{
   const response = await wById(warehouse_id);
   this.warehouse = response.data.data;
  }catch(error){
   this.$swalToast(error.message, 'error');
  }
 }, 

async warehouseItems(warehouse_id, page = 1){
 this.setLoading(true);
  try{
   const params = {
     page,
     search: this.search.trim() || ''
   };
   if (this.selectedBrand) params.brand_id = this.selectedBrand;
   if (this.selectedItem) params.item_id = this.selectedItem;   // ← NEW
   const query_string = new URLSearchParams(params).toString();
   const response = await axios.get(`/inventory/stocks/warehouse-items/${warehouse_id}?${query_string}`);
   this.data = response.data.data.data;
   this.pagination = {
    current_page: response.data.data.current_page,
    per_page: response.data.data.per_page,
    last_page: response.data.data.last_page,
    total: response.data.data.total,
    links: response.data.data.links 
   };
  }catch(error){
   this.$swalToast(error.message, 'error');
  }finally{
   this.setLoading(false);
  }
},

changePage(url){
  if(!url) return;
  const page = new URL(url).searchParams.get("page");
  this.warehouseItems(this.$route.params.warehouse_id, page);
},

clearFilter(){
 this.status = '';
 this.search = '';
 this.selectedBrand = null;
 this.selectedItem = null;
 this.items = [];
 this.warehouseItems(this.$route.params.warehouse_id, 1); 
}

 },
};
</script>


<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">

  <div class="me-2">
    <button class="btn btn-outline-primary btn-sm d-flex align-items-center" 
      @click="exportCSV" :disabled="!data || !data.length">
      <i class="ti ti-file-type-csv me-1"></i> Export CSV
    </button>
  </div>

  <div class="">
    <router-link :to="{name: 'warehouses'}" class="btn btn-primary btn-sm">
      <i class="ti ti-chevrons-left"></i> Warehouses
    </router-link>
  </div>

</div>
</div>
<!-- /Breadcrumb -->

<div class="card">
<div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
<h5><span class="text-primary">{{ warehouse?.name }}</span> Warehouse Items List</h5>
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">

<div class="me-3">
<vue-select
  v-model="selectedBrand"
  :options="brands"
  label="name"
  :reduce="b => b.id"
  placeholder="All Brands"
  :clearable="true"
  @update:modelValue="onBrandChange"
  style="min-width: 160px;"
></vue-select>
</div>

<div class="me-3" v-if="selectedBrand">
<vue-select
  v-model="selectedItem"
  :options="items"
  label="name"
  :reduce="i => i.id"
  placeholder="All Items"
  :clearable="true"
  @update:modelValue="onItemChange"
  style="min-width: 180px;"
></vue-select>
</div>
    
    <div class="me-3" v-if="search || status">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="search" placeholder="Search...."/>
    </div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="warehouseItems($route.params.warehouse_id, 1)"><i class="ti ti-search"></i></button>
    </div>

  </div>
 </div>

  <div class="card-body p-0">
  <div class="custom-datatable-filter table-responsive">
    <table class="table datatable thead-light" v-if="data?.length">
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Price</th>
          <th>Qty on hand</th>
          <th>Available Qty</th>
          <th>Reserved</th>
          <th>Opening Balance</th>
          <th>On Order Qty</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in data" :key="row.id">
        <td>{{ serialNo + index + 1 }}.</td>  
        <td> {{ row?.item?.name }} 
          <div>
            <a class="badge bg-light text-primary border rounded-pill me-1 mb-1 text-capitalize" @click="$copyText(row?.code)"> {{ row?.item?.code }} </a>
            <small class="text-muted d-block" style="font-size:11px;">Brand: {{ row?.item?.brand?.name || 'NA' }}</small>
          </div>
        </td>
        <td>{{ this.app_currency.symbol+row?.item?.price }}</td>
        <td>{{ parseInt(row.qty_on_hand) }}</td>
        <td>
        <span class="badge"
          :class="parseInt(row.available_qty) > 0 
            ? 'bg-success-transparent text-success' 
            : 'bg-danger-transparent text-danger'">
          {{ parseInt(row.available_qty) }}
        </span>
      </td>
        <td>{{ parseInt(row.reserved) }}</td>
        <td>{{ parseInt(row.opening_balance) }}</td>
        <td>{{ parseInt(row.on_order) }}</td>
        <td>
        <div class="dropdown">
        <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="ti ti-dots-vertical"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end p-3">

        <li>
        <a class="dropdown-item rounded-1" href="javascript:void(0);"><i class="ti ti-edit me-1"></i>No Action</a>
        </li>
        
        </ul>
        </div>  

        </td>
        </tr>
      </tbody>
    </table>

    <div v-else class="p-3 text-center text-muted"> No records found. </div>
  </div>

  <!-- Pagination -->
  <nav v-if="pagination.links.length > 3" class="m-3">
    <ul class="pagination pagination-sm">
      <li v-for="(link, index) in pagination.links" :key="index"
        :class="['page-item', { active: link.active, disabled: !link.url }]">
        <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
      </li>
    </ul>
  </nav>
  </div>

</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

</template>
<style scoped>
    .table-responsive {
        overflow-y: auto;
    }
</style>